(function (runtime) {
  var ticker = (function () {
    var callbacks = {};
    var status = "stopped";

    function tick(callback) {
      var frameFunc = function () {
          // get the current time rounded down to a whole second
          var now = 1000 * Math.floor(Date.now() / 1000);
          // run the callback
          callback(now);
          // wait for the next whole second
          setTimeout(timerFunc, now + 1000 - Date.now());
        },
        timerFunc = function () {
          if (status == "running") requestAnimationFrame(frameFunc);
        };
      timerFunc();
    }

    return {
      register: function (id, callback) {
        var o = {};
        o[id] = callback;

        callbacks = Object.assign(callbacks, o);
      },
      deregister: function (id) {
        delete callbacks[id];
      },
      has: function (id) {
        return callbacks[id] || null;
      },
      start: function () {
        if (status === "running") return;
        status = "running";
        tick(function (tickTime) {
          Object.values(callbacks).forEach(function (callback) {
            callback(tickTime);
          });
        });
      },
      stop: function () {
        status = "stop";
      },
      status: function () {
        return status;
      },
    };
  })();

  var constants = {
    keys: ["years", "months", "days", "hours", "minutes", "seconds"],
    css: {
      timerRunning: "ixp-timer-running",
      timerEnded: "ixp-timer-ended",
      years: "ixp-timer-show-year",
      months: "ixp-timer-show-month",
      days: "ixp-timer-show-day",
      hours: "ixp-timer-show-hour",
      minutes: "ixp-timer-show-minute",
      seconds: "ixp-timer-show-second",
    },
    selectors: {
      element: ".ixp-component-countdown-timer",
      counterItem: ".ixp-counter-item",
      years: ".ixp-year",
      months: ".ixp-month",
      days: ".ixp-day",
      hours: ".ixp-hour",
      minutes: ".ixp-minute",
      seconds: ".ixp-second",
      value: ".ixp-value",
      timerRunningContent: ".ixp-component-countdown-timer-running-content",
      timerEndedContent: ".ixp-component-countdown-timer-ended-content",
    },
  };

  /******************************************************************* */
  /* Time Handling functions inspired by moment.js diff                */
  /******************************************************************* */

  var momentDurationLight = (function () {
    var aliases = {
      years: "years",
      months: "months",
      days: "days",
      hours: "hours",
      minutes: "minutes",
      seconds: "seconds",
      milliseconds: "millseconds",
    };

    /******************************************************************* */
    /* Utils                                                             */
    /******************************************************************* */
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function absFloor(number) {
      if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }

    function normalizeUnits(units) {
      return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function monthsToDays(months) {
      // the reverse of daysToMonths
      return (months * 146097) / 4800;
    }

    function daysToMonths(days) {
      // 400 years have 146097 days (taking into account leap year rules)
      // 400 years have 12 months === 4800
      return (days * 4800) / 146097;
    }

    function makeGetter(name) {
      return function () {
        return this._data[name] ? this._data[name] : NaN;
      };
    }
    /******************************************************************* */
    /* Constructor                                                       */
    /******************************************************************* */
    function Duration(durationinMS) {
      this._milliseconds = durationinMS || 0;
      this._days = 0;

      this._months = 0;

      this._data = {};

      this._bubble();
    }

    var proto = Duration.prototype;

    proto.as = function (units) {
      var days,
        months,
        milliseconds = this._milliseconds;

      units = normalizeUnits(units);

      if (units === "months" || units === "years") {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
          case "months":
            return months;
          case "years":
            return months / 12;
        }
      } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case "days":
            return days + milliseconds / 864e5;
          case "hours":
            return days * 24 + milliseconds / 36e5;
          case "minutes":
            return days * 1440 + milliseconds / 6e4;
          case "seconds":
            return days * 86400 + milliseconds / 1000;
          default:
            throw new Error("Unknown unit " + units);
        }
      }
    };

    proto.asMilliseconds = function () {
      return this._milliseconds;
    };

    proto._bubble = function () {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;

      // if we have a mix of positive and negative values, bubble down first
      // check: https://github.com/moment/moment/issues/2166
      if (!((milliseconds >= 0 && days >= 0 && months >= 0) || (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }

      // The following code bubbles up values, see the tests for
      // examples of what that means.
      data.milliseconds = milliseconds % 1000;

      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;

      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;

      hours = absFloor(minutes / 60);
      data.hours = hours % 24;

      days += absFloor(hours / 24);

      // convert days to months
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));

      // 12 months -> 1 year
      years = absFloor(months / 12);
      months %= 12;

      data.days = days;
      data.months = months;
      data.years = years;

      return this;
    };

    proto.years = makeGetter("years");
    proto.months = makeGetter("months");
    proto.days = makeGetter("days");
    proto.hours = makeGetter("hours");
    proto.minutes = makeGetter("minutes");
    proto.seconds = makeGetter("seconds");
    proto.milliseconds = makeGetter("millseconds");

    return Duration;
  })();

  runtime.components.register("ixp-countdown-timer", {
    initialize: function (options) {
      // get native DOM element from jQuery Wrapper
      this._rootDOMEl = this.$el.get(0);
      this._endDate = new Date(Date.parse(this.endDate));
      this.updateTimer();

      ticker.register(this.instanceId, this.tick.bind(this));
    },
    onDocumentReady: function () {
      this.setupTimerItemVisibility();

      ticker.start();
    },
    onGetCssClassesToPreserve: function() {
      return [constants.css.years, constants.css.months, constants.css.days,constants.css.hours, constants.css.minutes,constants.css.seconds]
    },
    tick: function (tickTime) {
      this.updateTimer(tickTime);
      this.updateTimerDisplay();

      if (this._timer.expired == true && ticker.has(this.instanceId)) {
        ticker.deregister(this.instanceId);
      }
    },
    updateTimer: function (/* [now] */) {
      var _self = this,
        now = arguments[0] ? new Date(arguments[0]) : new Date(),
        dateDifference = new momentDurationLight(_self._endDate - now);

      var timer = constants.keys
        .filter(function (_, index, _array) {
          return index >= _array.indexOf(_self.shownAs);
        })
        .map(function (el, index) {
          var o = {};
          if (index > 0) {
            o[el] = Math.abs(dateDifference[el]());
          } else {
            o[el] = Math.abs(Math.floor(dateDifference.as(el)));
          }

          return o;
        })
        .reduce(function (acc, el) {
          return Object.assign(acc, el);
        }, {});

      timer.expired = dateDifference.asMilliseconds() < 0;

      _self._timer = timer;
    },
    setupTimerItemVisibility: function () {
      var _self = this;

      constants.keys.forEach(function (key) {
        _self._rootDOMEl.classList.toggle(constants.css[key], _self._timer[key] != null);
      });
    },
    updateTimerDisplay: function () {
      var _self = this;

      if (_self._timer.expired == true) {
        _self._rootDOMEl.classList.remove(constants.css.timerRunning);
        _self._rootDOMEl.classList.add(constants.css.timerEnded);
      }

      constants.keys.forEach(function (key) {
        var value = _self._timer.expired == true ? 0 : _self._timer[key] || 0;
        _self._rootDOMEl.querySelector(constants.selectors.counterItem + constants.selectors[key] + " " + constants.selectors.value).innerHTML = value.toString().padStart(2, 0);
      });
    },
    // studio
    onGetScaffolding: function (scaffoldingKey, builder, options) {
      return { scaffolding: [builder.scaffoldContainer("Countdown Timer")] };
    },
    allowedDropTargets: function () {
      return ["Container"];
    },
    getParamMapOverrides: function () {
      return {
        endDate: function (val) {
          this._endDate = new Date(Date.parse(val));
          if (!ticker.has(_self.instanceId)) {
            ticker.register(_self.instanceId, _self.tick.bind(_self));
          }
        },
        shownAs: function (val) {
          this.shownAs = ("" + val).toLowerCase();
          this.updateTimer();
          this.setupTimerItemVisibility();
          this.updateTimerDisplay();
        },
      };
    },
  });
})(window.ixp.runtime);
